import { render, staticRenderFns } from "./PolicyReinsurance.vue?vue&type=template&id=13d84400&"
import script from "./PolicyReinsurance.vue?vue&type=script&lang=js&"
export * from "./PolicyReinsurance.vue?vue&type=script&lang=js&"
import style0 from "./PolicyReinsurance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports